import React, { useState, useEffect, useRef } from "react";
import { Box, Container, Typography } from "@mui/material";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Marquee from "react-fast-marquee";
import web3 from "../../../Service/web3";
import "../../counter.css";
import { colors } from "../../../../theme/colors";
import HeroStats from "./heroStates.js";
import HeroActions from "./heroActions";
import { AutoBetGlobe } from "./three";
import heroBackground from "../../../../static/Images/heroBackground.png";
import {
  startMarqueeAnimation,
  startHeroBackgroundAnimation,
  startGlobeParallaxAnimation,
  startHeroEntryAnimation,
  cleanupAnimation,
  trustShineSx,
} from "../index.js";

const Hero = ({ item, bookies, lotteries, buytotal, draws, wins, variant }) => {
  const [featuredNews, setFeaturedNews] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [winnerNotifications, setWinnerNotifications] = useState([]);
  const [statsReady, setStatsReady] = useState(false);

  const autoBetRef = useRef(null);
  const heroBgRef = useRef(null);
  const heroContentRef = useRef(null);
  const globeRef = useRef(null);

  const apiUrl = process.env.REACT_APP_API_KEY;
  const history = useHistory();

  useEffect(() => {
    const animation = startMarqueeAnimation(autoBetRef);

    return () => cleanupAnimation(animation);
  }, []);

  useEffect(() => {
    const bgAnimation = startHeroBackgroundAnimation(heroBgRef);
    const globeAnimation = startGlobeParallaxAnimation(globeRef);

    return () => {
      cleanupAnimation(bgAnimation);
      cleanupAnimation(globeAnimation);
    };
  }, []);

  useEffect(() => {
    let animation;

    const startAnimation = () => {
      animation = startHeroEntryAnimation(heroContentRef, () => {
        setStatsReady(true);
      });
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(startAnimation);
    });

    return () => cleanupAnimation(animation);
  }, []);

  useEffect(() => {
    axios.get(`${apiUrl}/news/getAllNews`).then((response) => {
      const newsData = response.data.result;
      const featuredNewsData = newsData.filter((news) => news.featured);
      setFeaturedNews(featuredNewsData);
    });

    const fetchData = async () => {
      try {
        const account = await web3.eth.getAccounts();
        let skip = 0;
        let allNotifications = [];
        let allWinnerNotifications = [];

        const fetchNotifications = async () => {
          const response = await fetch(
            `${apiUrl}/notifications?limit=10&skip=${skip}`,
            {
              method: "GET",
              headers: { Authorization: account[0] },
            }
          );

          if (response.ok) {
            const data = await response.json();

            const filteredNotifications = data.result.filter(
              (notification) =>
                notification.type === "LotteryCreatedAdmin" ||
                notification.type === "LotteryCreated"
            );

            if (filteredNotifications.length > 0) {
              allNotifications = [
                ...allNotifications,
                ...filteredNotifications,
              ];
              skip += 10;
              await fetchNotifications();
            } else {
              setNotifications(allNotifications);
            }

            const filteredWinnerNotifications = data.result.filter(
              (notification) =>
                notification.type === "LotteryResult" ||
                notification.type === "SpinLotteryResult" ||
                notification.type === "LotteryWinner"
            );

            if (filteredWinnerNotifications.length > 0) {
              allWinnerNotifications = [
                ...allWinnerNotifications,
                ...filteredWinnerNotifications,
              ];
              skip += 10;
              await fetchNotifications();
            } else {
              setWinnerNotifications(allWinnerNotifications);
            }
          } else {
            console.error("Error fetching notifications:", response.error);
          }
        };

        await fetchNotifications();
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchData();
  }, []);

  function handleRedirect(notification) {
    switch (notification.type) {
      case "LotteryCreated":
        if (notification.lotteryName === "Missile")
          history.push(`/missilelottery/${notification.genId}`);
        else if (notification.lotteryName === "Mine")
          history.push(`/minelottery/${notification.genId}`);
        else if (notification.lotteryName === "MRL")
          history.push(`/lottery/${notification.genId}`);
        else history.push("/spinnerlottery");
        break;
      case "LotteryCreatedAdmin":
        if (notification.lotteryName === "Missile")
          history.push(`/missilelottery/${notification.genId}`);
        else if (notification.lotteryName === "Mine")
          history.push(`/minelottery/${notification.genId}`);
        else if (notification.lotteryName === "MRL")
          history.push(`/lottery/${notification.genId}`);
        else history.push("/spinnerlottery");
        break;
      default:
        break;
    }
  }

  return (
    <Container maxWidth={false} disableGutters sx={{ p: 0 }}>
      {((featuredNews !== undefined && featuredNews.length > 0) ||
        (notifications !== undefined && notifications.length > 0)) && (
        <Box sx={{ m: 0, p: 0 }}>
          <Marquee pauseOnHover gradient className="marq">
            {featuredNews.map((news) => (
              <span key={news.id} className="feature-msg mx-4">
                <a href={`/news/${news.id}`}>{news.title}</a>
              </span>
            ))}
            {notifications.slice(0, 3).map((item) => (
              <span
                key={item.id}
                onClick={() => handleRedirect(item)}
                className="feature-msg mx-4"
                style={{ cursor: "pointer" }}
              >
                ID-{item.genId}: "{item.title}"
              </span>
            ))}
            {winnerNotifications.slice(0, 3).map((item) => (
              <span
                key={item.id}
                onClick={() => history.push("/lottery-result")}
                className="feature-msg mx-4"
                style={{ cursor: "pointer" }}
              >
                ID-{item.genId}: "{item.title}"
              </span>
            ))}
          </Marquee>
        </Box>
      )}

      <Box
        className="banner-section"
        sx={{
          position: "relative",
          minHeight: { xs: "auto", md: "calc(100vh - 80px)" },
          height: { xs: "auto", md: "calc(100vh - 80px)" },
          overflow: "hidden",
          background: (theme) => theme.palette.background.default,
        }}
      >
        <Box
          ref={heroBgRef}
          className="hero-bg-layer"
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 0,
            backgroundImage: `url(${heroBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            willChange: "transform",
          }}
        />

        <Box
          ref={globeRef}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            width: "55%",
            zIndex: 1,
            pointerEvents: "none",
            willChange: "transform",
          }}
        >
          <AutoBetGlobe />
        </Box>

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 2,
            background: (theme) =>
              `linear-gradient(90deg, ${theme.custom.colors.alpha.cream[96]} 0%, ${theme.custom.colors.alpha.cream[88]} 32%, ${theme.custom.colors.alpha.cream[30]} 62%, ${theme.custom.colors.alpha.cream[5]} 100%)`,
            pointerEvents: "none",
          }}
        />

        <Box
          className="banner-content-area"
          sx={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            alignItems: "flex-start",
            pt: "30px",
          }}
        >
          <Container
            maxWidth={false}
            disableGutters
            sx={{
              px: { xs: 3, sm: 4, md: 6, lg: 6 },
              pt: 0,
              pb: { xs: 8, md: 12 },
            }}
          >
            <Box
              ref={heroContentRef}
              sx={{
                width: "100%",
                maxWidth: "900px",
              }}
            >
              <Box
                className={`banner-content${
                  variant === "home" ? " home-hero" : ""
                }`}
                sx={{
                  width: "100%",
                  justifyContent: "flex-start",
                }}
              >
                {variant === "home" && (
                  <Box
                    component="p"
                    className="home-kicker hero-entry-item"
                    sx={{
                      color: (theme) => theme.palette.text.secondary,
                      textTransform: "uppercase",
                      fontSize: { xs: "8px", sm: "8px", md: "8px" },
                      whiteSpace: "nowrap",
                      fontWeight: 500,
                      letterSpacing: "1.4px",
                      display: "flex",
                      alignItems: "center",
                      gap: "11px",
                      margin: 0,
                      mb: { xs: 2, md: 3 },
                      "&::before": {
                        content: '""',
                        width: "30px",
                        height: "2px",
                        borderRadius: "2px",
                        background: (theme) => theme.palette.text.primary,
                        flexShrink: 0,
                      },
                    }}
                  >
                    DECENTRALIZED LOTTERY & GAMING ECOSYSTEM
                  </Box>
                )}

                <Typography
                  component="h1"
                  className="title hero-entry-item"
                  sx={{
                    textAlign: "left",
                    fontWeight: 800,
                    color: (theme) => theme.palette.text.primary,
                    margin: 0,
                    mb: { xs: "16px", md: "24px" },
                    fontSize: {
                      xs: "3rem",
                      sm: "3.5rem",
                      md: "4rem",
                      lg: "4.5rem",
                    },
                    letterSpacing: "2.5px",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                  }}
                >
                  Play. Win.{" "}
                  <Box
                    component="span"
                    sx={trustShineSx(colors.primary.main)}
                  >
                    Trust.
                  </Box>
                </Typography>

                <Typography
                  component="p"
                  className="hero-entry-item"
                  sx={{
                    color: (theme) => theme.palette.text.secondary,
                    fontSize: { xs: "8px", sm: "8px", md: "8px" },
                    lineHeight: 1.55,
                    maxWidth: "800px",
                    margin: 0,
                    mb: { xs: "16px", md: "24px" },
                  }}
                >
                  AutoBET is a next-generation blockchain lottery and gaming
                  platform featuring fair, transparent and globally accessible
                  games like Powerball, Revolver, Pokies and more — all powered
                  by smart contracts.
                </Typography>

                <Box className="hero-entry-item">
                  <HeroStats
                    bookies={bookies}
                    lotteries={lotteries}
                    buytotal={buytotal}
                    draws={draws}
                    wins={wins}
                    startAnimation={statsReady}
                  />
                </Box>

                {variant === "home" && (
                  <Box
                    className="hero-entry-item"
                    sx={{
                      mt: { xs: 0.5, md: 1 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <HeroActions history={history} />
                  </Box>
                )}
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    </Container>
  );
};

export default Hero;